<template>
  <div id="my-app" class="page-wrapper">
    <transition
      name="loader-animation"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut">
      <div class="progress loader" v-if="showLoader">
        <div class="progress-bar" role="progressbar" :style="loaderStyle" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    </transition>
    
    <transition name="page-transition"
      enter-active-class="animated fadeIn" 
      leave-active-class="animated fadeOut"
      mode="out-in" appear
     >
      <app-header v-if="!showLoader"></app-header>
    </transition>

    <div class="loader-circle" v-if="showLoader && loaderExecute"></div>

    <transition name="page-transition"
      enter-active-class="animated fadeIn" 
      leave-active-class="animated fadeOut"
      mode="out-in" appear
     >
      <div class="page-content-wrapper" v-if="!showLoader">
        <router-view></router-view>
      </div>
    </transition>

    <transition name="page-transition"
      enter-active-class="animated fadeIn" 
      leave-active-class="animated fadeOut"
      mode="out-in" appear
    >
      <app-footer v-if="!showLoader"></app-footer>
    </transition>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Header from './components/partials/Header'
import Footer from './components/partials/Footer'

export default {
    data() {
      return {
          showLoader: true,
          loaderExecute: true,

          searching: false,
      }
    },

    mounted() {
      var search = document.getElementsByClassName("gsc-control-cse")
      if(search.length){
        this.searching = true;
      } else {
        this.searching = false;
      }
    },

    computed: {
      ...mapGetters({
          isLoading: 'isLoading',
          loadingProgress: 'loadingProgress'
      }),

      loaderStyle() {
          return `width: ${this.loadingProgress}%;`
      },
    },

    components: {
        appHeader: Header,
        appFooter: Footer
    },

  watch: {
    // watch the value of isLoading and once it's false hide the loader
    isLoading(val) {
      if (val == false) {
        let self = this
        setTimeout(function(){
          self.loaderExecute = false
          self.showLoader = false
        }, 1000)
      }
    },

    '$route.path'(){
      let self = this

      self.showLoader = true
      setTimeout(function(){
        self.loaderExecute = true
      }, 800)
      setTimeout(function(){
        self.showLoader = false
        self.loaderExecute = false
      }, 2800)
    }
  }
}
</script>
<style lang="scss">
  @import './styles/app.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue